import { useDispatch, useSelector } from 'react-redux';
import { isOnboardedForPharma } from '../../../../../../../pages/utils';
import {
    fetchDrugsSubstitute,
    updateTranslate,
} from '../../../../../../../store/actions/prescriptionPad';
import TemplateIcons from '../../TemplateIcons';
import { setPincode } from '../../../../../../../store/actions/session';
import { getPincode } from '../../../../../../../store/selectors/session';
import CircleInfoSolid from '../../../../../../../icons/solid/circle-info-solid';
import { getTranslate } from '../../../../../../../store/selectors/prescriptionPad';
import { getAllLang } from '../../../../previewScreen/PreviewPanel';
import { track } from '../../../../../../../tracking';
import ConfigureInjectionTable from '../ConfigureInjectionTable';

const ModuleActions = (): JSX.Element => {
    const dispatch = useDispatch();
    const pincode = useSelector(getPincode);
    const translate = useSelector(getTranslate);
    const ALL_LANGUAGES = getAllLang();

    const isDoctorPharmaOnboarded = isOnboardedForPharma();
    return (
        <div className="flex flex-wrap items-center space-x-12">
            {isDoctorPharmaOnboarded ? (
                <div className="flex items-center space-x-8">
                    <CircleInfoSolid className="w-14 h-15 fill-darwin-neutral-700" />
                    <span className="text-13">Delivery Pincode:</span>
                    <input
                        value={pincode}
                        placeholder="pincode"
                        className="border rounded-4 w-72 px-8"
                        onChange={(e) => {
                            const value = e.target.value.trim();
                            if (value.length > 6) return;
                            dispatch(setPincode(e.target.value.trim()));
                        }}
                        type="number"
                    />
                    <button
                        className="flex items-center space-x-8 px-12 border border-darwin-primary-500 rounded-4"
                        onClick={() => {
                            dispatch(fetchDrugsSubstitute());
                        }}
                    >
                        <span>
                            <svg
                                className="w-12 h-13 fill-darwin-primary-500"
                                viewBox="0 0 12 13"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M10.6406 7.27344C10.9453 7.36719 11.1094 7.67188 11.0156 7.97656C10.3594 10.2031 8.29688 11.75 5.97656 11.75C4.125 11.75 2.41406 10.7422 1.47656 9.17188V11.5625C1.47656 11.8906 1.24219 12.125 0.914062 12.125C0.609375 12.125 0.351562 11.8906 0.351562 11.5625V7.8125C0.351562 7.50781 0.609375 7.25 0.914062 7.25H4.66406C4.99219 7.25 5.22656 7.50781 5.22656 7.8125C5.22656 8.14062 4.96875 8.375 4.66406 8.375H2.29688C3 9.73438 4.40625 10.625 5.97656 10.625C7.80469 10.625 9.44531 9.40625 9.9375 7.64844C10.0312 7.34375 10.3359 7.17969 10.6406 7.27344ZM11.0625 0.875C11.3672 0.875 11.625 1.13281 11.625 1.4375V5.1875C11.625 5.51562 11.3672 5.75 11.0625 5.75H7.3125C6.98438 5.75 6.75 5.51562 6.75 5.1875C6.75 4.88281 6.98438 4.625 7.3125 4.625H9.65625C8.95312 3.28906 7.54688 2.375 6 2.375C4.17188 2.375 2.53125 3.61719 2.01562 5.35156C1.94531 5.65625 1.64062 5.82031 1.33594 5.72656C1.03125 5.65625 0.867188 5.32812 0.9375 5.04688C1.59375 2.82031 3.67969 1.25 6 1.25C7.85156 1.25 9.5625 2.28125 10.5 3.85156V1.4375C10.5 1.13281 10.7344 0.875 11.0625 0.875Z" />
                            </svg>
                        </span>
                        <span className="text-darwin-primary-500">Check</span>
                    </button>
                </div>
            ) : null}

            <div className="flex items-center gap-16 flex-wrap">
                <div className="flex items-center space-x-4 text-neutral-black text-12 leading-3 bg-neutral-9 rounded-4 px-8 py-2">
                    <div className="flex items-center justify-center w-12 h-12">
                        <svg
                            className="w-12 h-12 fill-neutral-3"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z"></path>
                        </svg>
                    </div>
                    <div className="flex items-baseline space-x-4">
                        <p>Default Instructions:</p>
                        <select
                            tabIndex={-1}
                            value={
                                translate.flag &&
                                (translate.injections || translate.injections === undefined)
                                    ? translate.lang
                                    : 'off'
                            }
                            onChange={(e) => {
                                track('PX_TRANSLATE', {
                                    lang: e.target.value,
                                    flag: e.target.value,
                                    action: 'select',
                                });
                                dispatch(
                                    updateTranslate({
                                        ...translate,
                                        lang:
                                            e.target.value !== 'off'
                                                ? e.target.value
                                                : translate.lang,
                                        flag: e.target.value !== 'off' ? true : translate.flag,
                                        injections: e.target.value === 'off' ? false : true,
                                    }),
                                );
                            }}
                            className="bg-transparent text-12 cursor-pointer"
                        >
                            <option value={'off'}>{'Off'}</option>
                            {ALL_LANGUAGES.map((language) => (
                                <option key={language.code} value={language.code}>
                                    {language.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <TemplateIcons pxToolKey={'injections'} withPeak={true} isModal={false} />
                <ConfigureInjectionTable />
            </div>
        </div>
    );
};

export default ModuleActions;
